import { render, staticRenderFns } from "./addChildAccount.vue?vue&type=template&id=5da381df&scoped=true"
import script from "./addChildAccount.vue?vue&type=script&lang=js"
export * from "./addChildAccount.vue?vue&type=script&lang=js"
import style0 from "./addChildAccount.vue?vue&type=style&index=0&id=5da381df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da381df",
  null
  
)

export default component.exports